import React from 'react';
import { ISite } from '../SiteList';
import * as S from './SiteRow.styles';

interface ISiteRow {
  site: ISite;
  disableLinks: boolean;
  onSelect: (site:ISite) => void;
}
export default function SiteRow({ site, disableLinks, onSelect }: ISiteRow ): JSX.Element {
    return (disableLinks ?
        <S.SiteLinkDiv>
            <S.SiteLinkDisabled> {site.name} </S.SiteLinkDisabled>
        </S.SiteLinkDiv> :
        <S.SiteLinkDiv onClick={() => onSelect(site)}>
            <S.SiteLink> {site.name} </S.SiteLink>
        </S.SiteLinkDiv>
    );
};
